import React from 'react';

import { makeStyles } from "@utilities/theme_utilities";

interface Props {
  disabled?: boolean;
  label: string;
  to: string;
  target: string;
}

export default function LinkButton({ 
  disabled = false,
  label,
  to,
  target
}: Props) {
  
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        textDecoration: "none"
      }
    });
  });
  const { classes, cx } = useStyles();

  if (disabled) {
    return (<span className={cx(classes.root, "link_button")} style={{
      color: "rgba(255, 255, 255, 0.3)",
      boxShadow: "none",
      backgroundColor: "rgba(255, 255, 255, 0.12)"
    }}>{label}</span>);
  } else {
    return (
      <a target={target} href={to} className={cx(classes.root, "link_button")}>{label}</a>
    );
  }
}

// <button class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium css-j1zs2x-MuiButtonBase-root-MuiButton-root" tabindex="0" type="button"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="RefreshIcon"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path></svg>&nbsp;Reload from DB<span class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span></button>
// <a class="css-psqpvz-root MyButton" target="_blank" href="/character/printable/638bdf555c17eb0008ef8935">Printable PDF</a>